module.exports = __webpack_public_path__ + "static/media/meowing-cat.5327c3d7.png";